import { Injectable } from '@angular/core';
import { ApiResponse } from "app/entities";
import { Unit } from 'app/entities/unit';
import { ApiService } from "app/services/api.service";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UnitService extends ApiService {

    findAll(params: any) {
        params = this.paramsFromObject(params);
        params.summed_up = false
        return this.httpService.get(`/v1/clients/units/index`, params)
            .pipe(
                map(res => ApiResponse.parseWith(new Unit, res) as ApiResponse<Unit[]>)
            )
    }

    simpleUnitsAll() {
        return this.httpService.get(`/v1/clients/units/simple-units`, {}).pipe(
            map(res => ApiResponse.parseWith(new Unit, res) as ApiResponse<Unit[]>)
        )
    }

    store(data: any) {
        let formData = this.formDataFromObject(data)
        return this.httpService.post(`/v1/clients/units`, formData)
            .pipe(
                map(res => Unit.parse(res.data) as Unit)
            )
    }

    update(id: number, data: any) {
        let formData = this.formDataFromObject(data)
        return this.httpService.post(`/v1/clients/units/${id}`, formData)
            .pipe(
                map(res => Unit.parse(res.data) as Unit)
            )
    }

    destroy(id: number) {
        return this.httpService.delete(`/v1/clients/units/${id}/delete`)
    }

    find(id: any) {
        return this.httpService.get(`/v1/clients/units/${id}`)
            .pipe(
                map(res => Unit.parse(res.data) as Unit)
            )
    }

    hasLimit() {
        return this.httpService.get(`/v1/clients/units/limit`);
    }
}
